import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * EVG: the Klarna instalments inside the Klarna payment message block.
 * The amounts are rendered in Liquid; when the variant changes, the copy is
 * replaced with the same block from the page the variant picker just fetched.
 */
class KlarnaInstallments extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  /**
   * Updates the instalments.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInstallments = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = CSS.escape(this.dataset.blockId ?? '');
    const newInstallments = event.detail.data.html.querySelector(`klarna-installments[data-block-id="${blockId}"]`);

    if (!newInstallments) return;

    if (newInstallments.innerHTML !== this.innerHTML) {
      this.innerHTML = newInstallments.innerHTML;
    }
  };
}

if (!customElements.get('klarna-installments')) {
  customElements.define('klarna-installments', KlarnaInstallments);
}
